<template>
  <div ref="debateHolder" class="debate-holder" v-if="!debateNotFound" :class="{
    'is-poll': isPoll,
    'is-login': globals.state === 'login' || globals.state === 'forgot',
    'is-register': globals.state === 'signup',
    'width-xl': adPosition.includes('wide_format'),
  }">
    <LoadingAnimation v-if="loading" />
    <div class="main-panel" v-if="!loading">
      <FormBox v-if="form" :form="form" />

      <template v-else-if="debates.length">
        <DebateBox :debate-id="debate.id" v-for="debate in debates" v-bind:key="debate.id" :debate="debate"
          :showTopComment="showTopComment && !network" />
      </template>

      <template v-else>
        <DebateBox :debate-id="debate.id" v-if="debate" :debate="debate" :showTopComment="showTopComment"
          :showConversionButton="(debate.votedSideId || debate.isClosed) /*&& isConversion*/ &&
            debate.affiliateLink &&
            debate.affiliateButtonText
            " :registerConversionEvent="registerConversionEvent" />

        <EmailModal v-if="showEmailModal" :debate="debate" />
      </template>

      <LoginForm v-if="globals.state === 'login' && !sidePanelVisible" :isStacked="false" :debate="debate" />

      <ForgotPasswordForm v-if="globals.state === 'forgot' && !sidePanelVisible" :isStacked="false" />

      <SignUpForm v-if="globals.state === 'signup' && !sidePanelVisible" :isStacked="false" :debate="debate" />

      <span class="version-number">v.11.1.6</span>
    </div>
  </div>

  <SidePanel v-if="sidePanelVisible" :showProfile="showProfile" :feedDebateArguments="feedDebateArguments"
    :networkDebates="networkDebates" :loadMore="loadMore" :loading="loading" :debate="debate" />

  <div class="success-alert" v-if="successMessage">{{ successMessage }}</div>
</template>

<script>
import axios from "axios";
import { computed, defineAsyncComponent } from "vue";
import Argument from "./argument";
import "./assets/main.sass";
import Debate from "./debate";
const FormBox = defineAsyncComponent(() => import("./components/FormBox.vue"));
const DebateBox = defineAsyncComponent(
  () => import("./components/DebateBox.vue"),
);
const LoginForm = defineAsyncComponent(
  () => import("./components/LoginForm.vue"),
);
const ForgotPasswordForm = defineAsyncComponent(
  () => import("./components/ForgotPasswordForm.vue"),
);
const EmailModal = defineAsyncComponent(
  () => import("./components/EmailModal.vue"),
);
const SignUpForm = defineAsyncComponent(
  () => import("./components/SignUpForm.vue"),
);
const LoadingAnimation = defineAsyncComponent(
  () => import("./components/LoadingAnimation.vue"),
);
const SidePanel = defineAsyncComponent(
  () => import("./components/SidePanel.vue"),
);

export default {
  name: "App",
  components: {
    FormBox,
    DebateBox,
    LoginForm,
    ForgotPasswordForm,
    LoadingAnimation,
    SignUpForm,
    EmailModal,
    SidePanel,
  },
  data() {
    const { location } = window;
    const { href, hash } = location;
    let hrefLocation;
    try {

      const displayContentElement = document.getElementById("displayContent");
      const pageHrefFromAttribute = displayContentElement ? displayContentElement.getAttribute("data-page-href") : null;
      hrefLocation = (window.self !== window.top) && pageHrefFromAttribute
        ? pageHrefFromAttribute
        : href;
    } catch (e) {
      hrefLocation = href;
    }

    return {
      adSuffix: 1,
      loading: true,
      loadMore: false,
      allDebatesLoaded: false,
      currentPage: 1,
      debateId: 0,
      overrideAds: null,
      overrideComments: null,
      overrideAdPosition: null,
      overrideMultiple: null,
      form: null,
      debate: null,
      debateClient: null,
      nextDebate: null,
      debateHistory: [],
      debateNextList: [],
      feedDebate: null,
      feedDebateArguments: [],
      debates: [],
      arguments: [],
      globals: {
        pageUrl: (hrefLocation.indexOf("?") !== -1
          ? hrefLocation.substring(0, hrefLocation.indexOf("?"))
          : hrefLocation
        )
          .replace(hash, "")
          .replace("#", ""),
        refCookieName: "L2b5N2b9M0",
        accessTokenCookieName: "L2b5N2b9M_at",
        refreshTokenCookieName: "L2b5N2b9M_rt",
        verifiedUserCookieName: "L2b5N2b9M_vu4",
        verifiedUserIdCookieName: "L2b5N2b9M_vui1",
        deviceId: new ClientJS().getFingerprint(), // eslint-disable-line
        authTokenKey: "api_auth_token",
        authToken: "",
        accessToken: "",
        refreshToken: "",
        userKey: "",
        textMaxLength: 60,
        userInfoNeeds: "",
        pendingAction: "",
        pendingActionData: null,
        state: "default",
        userInfo: null,
      },
      debateNotFound: false,
      adsHidden: false,
      adsAdSense: false,
      adsOutbrain: false,
      adsOutbrainLoaded: false,
      adsTaboola: false,
      adsDataBlocks: false,
      adsRevContent: false,
      adPosition: "bottom",
      isPoll: false,
      isQuiz: false,
      isConversion: false,
      network: 0,
      clientId: 0,
      embedPlacementId: 0,
      embedPlacementData: null,
      adCode: null,
      adCodeMobile: null,
      showTopComment: true,
      sidePanelVisible: false,
      sidePanelTab: "standard",
      networkDebates: [],
      networkDebatesPage: 1,
      allNetworkDebatesLoaded: false,
      networkIdentity: null,
      profileUser: null,
      profileState: "",
      contentOptionsType: "",
      contentOptionsItem: null,
      showProfile: false,
      widgetCssClass: "",
      userIsVerified: false,
      requireEmail: 0,
      requireEmailWasClosed: false,
      successMessage: "",
      replyArgumentId: 0,
      replyCommentId: 0,
      votingStarted: false,
      updateSessionWasDone: false,
      sidebarAds: false,
      pollImpressionViewedEventFired: false,
    };
  },
  provide() {
    return {
      isPoll: computed(() => this.isPoll),
      isQuiz: computed(() => this.isQuiz),
      adCode: computed(() => this.adCode),
      adCodeMobile: computed(() => this.adCodeMobile),
      globals: computed(() => this.globals),
      adSuffix: computed(() => this.adSuffix),
      arguments: computed(() => this.arguments),
      adsHidden: computed(() => this.adsHidden),
      feedDebate: computed(() => this.feedDebate),
      adsAdSense: computed(() => this.adsAdSense),
      adPosition: computed(() => this.adPosition),
      sidebarAds: computed(() => this.sidebarAds),
      adsAditude: computed(() => this.adsAditude),
      adsTaboola: computed(() => this.adsTaboola),
      adsDataBlocks: computed(() => this.adsDataBlocks),
      adsOutbrain: computed(() => this.adsOutbrain),
      profileUser: computed(() => this.profileUser),
      debateClient: computed(() => this.debateClient),
      sidePanelTab: computed(() => this.sidePanelTab),
      requireEmail: computed(() => this.requireEmail),
      votingStarted: computed(() => this.votingStarted),
      debateHistory: computed(() => this.debateHistory),
      adsRevContent: computed(() => this.adsRevContent),
      showNextDebate: computed(() => this.showNextDebate),
      widgetCssClass: computed(() => this.widgetCssClass),
      userIsVerified: computed(() => this.userIsVerified),
      replyCommentId: computed(() => this.replyCommentId),
      showEmailModal: computed(() => this.showEmailModal),
      changeDebateFromHistory: computed(() => this.changeDebateFromHistory),
      networkIdentity: computed(() => this.networkIdentity),
      replyArgumentId: computed(() => this.replyArgumentId),
      debateHolder: computed(() => this.$refs.debateHolder),
      sidePanelVisible: computed(() => this.sidePanelVisible),
      contentOptionsType: computed(() => this.contentOptionsType),
      contentOptionsItem: computed(() => this.contentOptionsItem),
      sequenceId: computed(() => this.sequenceId),
      embedPlacementData: computed(() => this.embedPlacementData),
      aditudeAdCounter: computed(() => window.aditudeAdCounter || 1),
      isMobile: () => this.isMobile(),
      onLogOut: () => this.onLogOut(),
      initLogin: () => this.initLogin(),
      initSignup: () => this.initSignup(),
      isInfinite: () => this.isInfinite(),
      closeProfile: () => this.closeProfile(),
      loadProfile: (id) => this.loadProfile(id),
      onBackFromFeed: () => this.onBackFromFeed(),
      getOutbrainAdId: () => this.getOutbrainAdId(),
      closeEmailModal: () => this.closeEmailModal(),
      fireEvent: (payload) => this.fireEvent(payload),
      fireEventGA: (event, payload) => this.fireEventGA(event, payload),
      loadNetworkDebates: () => this.loadNetworkDebates(),
      onCloseSidePanel: () => this.onCloseSidePanel(),
      initDebate: (debate) => this.initDebate(debate),
      openProfile: (user = null, allowOpen = false) =>
        this.openProfile(user, allowOpen),
      onVote: (debate, side) => this.onVote(debate, side),
      onFormSubmit: (formCaption) => this.onFormSubmit(formCaption),
      setFeedDebate: (debate) => this.setFeedDebate(debate),
      loadJs: (src, callback = null, id = "") => this.loadJs(src, callback, id),
      resetContentOptions: () => this.resetContentOptions(),
      loadUserInfo: (callback) => this.loadUserInfo(callback),
      setGlobals: (key, value) => this.setGlobals(key, value),
      refreshDebateHistory: () => this.refreshDebateHistory(),
      copyToClipboard: (text = "") => this.copyToClipboard(text),
      setSidePanelTab: (newState) => this.setSidePanelTab(newState),
      onLikeComment: (type, comment) => this.onLikeComment(type, comment),
      onLikeArgument: (type, argument) => this.onLikeArgument(type, argument),
      showContentOptions: (type, item) => this.showContentOptions(type, item),
      setCookie: (cookieName, cookieValue) =>
        this.setCookie(cookieName, cookieValue),
      loadDebate: (
        callback = null,
        justRefresh = false,
        specificDebateId = 0,
      ) => this.loadDebate(callback, justRefresh, specificDebateId),
      closeContentOptions: (sidePanelVisible = false) =>
        this.closeContentOptions(sidePanelVisible),
      getCookie: (cookieName, useLocalStorage = false) =>
        this.getCookie(cookieName, useLocalStorage),
      refreshAuthToken: (callback = null, enableFallback = false) =>
        this.refreshAuthToken(callback, enableFallback),

      onShare: () => {
        this.copyToClipboard(
          window.location.href.replace(window.location.hash, "") +
          "#" +
          this.$refs.debateHolder.id,
        );

        alert(this.$t("Link copied to clipboard"));
      },
      stopReply: () => {
        this.replyArgumentId = 0;
        this.replyCommentId = 0;
      },
      replyToArgument: (id) => (this.replyArgumentId = id),
      replyToComment: (id) => (this.replyCommentId = id),
      onShowSidePanel: (debate, showFeed = false) => {
        this.debate = debate;

        if (this.network) {
          this.arguments = [];
          this.loadFeed();
        }

        const holder =
          this.$refs.debateHolder.parentElement.parentElement.parentElement;
        if (holder.style.cssText.indexOf("transform") !== -1) {
          holder.style = "";
        }

        if (window.location.host === "dodgerblue.com") {
          document.querySelector("#secondary .sidebar").style.zIndex = 9999999;
        } else if (window.location.host === "www.retroheadz.com") {
          document.querySelector(".single-content").style.zIndex = "auto";
        } else if (window.location.host === "truthpress.com") {
          document
            .querySelector(".theiaStickySidebar")
            .classList.add("reset-fixed-translate");
        }

        if (showFeed === true) {
          if (this.debate.redirectSidePanel) {
            window.open(
              this.debateClient.siteUrl,
              "_blank",
            );
          } else {
            this.sidePanelVisible = true;
            this.setSidePanelTab("standard");
            this.loadNetworkDebates();
          }
        } else if (this.debate.redirectSidePanel) {
          window.open(
            `${this.debateClient.siteUrl}/${this.debate.user.username}/${this.debate.slug}`,
            "_blank",
          );
        } else {
          this.sidePanelVisible = true;
          setTimeout(() => window.OBR.extern.researchWidget(), 500);
        }

        window.sidedAnalytics.logEvent("open_sidepanel", {
          pagename: this.debate.thesis,
        }); // eslint-disable-line
        this.fireEventGA("open_sidepanel", { pagename: this.debate.thesis });
      },
      resetProfileState: () => (this.profileState = ""),
      verifyUser: (email, id) => {
        this.userIsVerified = true;
        this.setCookie(this.globals.verifiedUserCookieName, email, true);
        this.setCookie(this.globals.verifiedUserIdCookieName, id, true);
      },
      showSuccessMessage: (message) => {
        this.successMessage = message;

        setTimeout(() => (this.successMessage = ""), 3000);
      },
      getPageUrl() {
        return window.location.href;
      },
    };
  },
  computed: {
    showEmailModal() {
      return (
        this.requireEmail &&
        !this.userIsVerified &&
        !this.globals.userInfo &&
        !this.debate.isClosed &&
        this.debate.votedSideId &&
        !this.requireEmailWasClosed
      );
    },
  },
  created() {
    window.sidedAdSuffix = window.sidedAdSuffix
      ? parseInt(window.sidedAdSuffix) + 1
      : 1;

    this.adSuffix = window.sidedAdSuffix;
  },
  mounted: async function () {
    const debateHolder = this.$refs.debateHolder;
    this.debateId = parseInt(
      debateHolder.parentElement.getAttribute("debateid"),
    );
    this.categories = [];
    const categoriesFromAttributes =
      debateHolder.parentElement.getAttribute("categories");
    if (categoriesFromAttributes?.length > 0) {
      this.categories = categoriesFromAttributes.split(",").filter((category) => Boolean(category.trim()));
    }
    this.overridePollVisibility = debateHolder.parentElement.getAttribute("override-poll-visibility")
    this.embedFor =
      debateHolder.parentElement.getAttribute("embedFor");
    this.embedPlacementId = parseInt(
      debateHolder.parentElement.getAttribute("placementid"),
    );

    this.collectionData = {};
    this.clientId = parseInt(
      debateHolder.parentElement.getAttribute("clientid"),
    );
    this.sequenceId = parseInt(
      debateHolder.parentElement.getAttribute("sequenceId"),
    );

    this.formId = parseInt(
      debateHolder.parentElement.getAttribute("formId"),
    );

    this.network = parseInt(debateHolder.parentElement.getAttribute("network"));
    this.overrideAdPosition =
      debateHolder.parentElement.getAttribute("data-ad-position");
    this.overrideComments =
      debateHolder.parentElement.getAttribute("data-comments");
    this.overrideAds = debateHolder.parentElement.getAttribute("data-ads");
    this.overrideMultiple =
      debateHolder.parentElement.getAttribute("data-multiple-polls") ===
      "false";
    this.userIsVerified = !!this.getCookie(
      this.globals.verifiedUserCookieName,
      true,
    );

    axios.interceptors.request.use((config) => {
      config.baseURL = config.isNewAPI ? `${process.env.VUE_APP_API_V7_BASE_URL}` : `${process.env.VUE_APP_BASE_API_URL}`;
      if (!config.isNewAPI) {
        config.headers["x-auth-token"] = this.globals.authToken;
        config.headers["x-access-token"] = this.globals.accessToken;
        config.headers["x-source-type"] = "embed";
      }


      if (this.debate && this.debate.siteDomain) {
        config.headers["x-network-domain"] = this.debate.siteDomain;
      }

      return config;
    });

    const sidedEmbedPayloadJson = this.getData("sidedEmbedPayload");
    if (sidedEmbedPayloadJson) {
      const sidedEmbedPayload = JSON.parse(sidedEmbedPayloadJson);

      if (sidedEmbedPayload.sidePanelVisible) {
        this.sidePanelVisible = sidedEmbedPayload.sidePanelVisible;
      }

      this.removeData("sidedEmbedPayload");
    }

    this.widgetCssClass = debateHolder.offsetWidth < 578 ? "size-s" : "";
    window.addEventListener(
      "resize",
      () =>
        (this.widgetCssClass = debateHolder.offsetWidth < 578 ? "size-s" : ""),
    );

    if (this.overrideAdPosition) {
      this.adPosition = this.overrideAdPosition;
    }

    const debateHolderId = `sided-${this.debateId || 0}-${this.clientId || 0}-${this.embedPlacementId || 0
      }-${this.network || 0}-${this.sequenceId || 0}`;
    debateHolder.id = debateHolderId;

    if (window.location.hash.replace("#", "") === debateHolderId) {
      setTimeout(function () {
        window.scrollTo(0, debateHolder.offsetTop);
      }, 500);
    }

    this.globals.userKey = this.getCookie(this.globals.refCookieName);
    this.globals.authToken = this.getCookie(this.globals.authTokenKey);
    this.globals.accessToken = this.getCookie(
      this.globals.accessTokenCookieName,
    );
    this.globals.refreshToken = this.getCookie(
      this.globals.refreshTokenCookieName,
    );

    let authToken = this.getCookie(this.globals.authTokenKey);

    if (authToken) {
      await this.getDataFromEmbed();
      this.initData();
    }

    if (!authToken) {
      this.generateAuthToken(async () => {
        await this.getDataFromEmbed();
        this.initData();
      })
    }

    if (this.network) {
      window.addEventListener("scroll", () => {
        if (
          document.body.offsetHeight - window.innerHeight - window.scrollY <
          50 &&
          !this.loadMore &&
          !this.allDebatesLoaded
        ) {
          this.loadNextPage();
        }
      });
    }

    setTimeout(() => {
      if (
        this.$refs.debateHolder &&
        window.location.hash.replace("#", "") === this.$refs.debateHolder.id
      ) {
        window.scrollTo(0, this.$refs.debateHolder.offsetTop);
      }
    }, 1000);

    this.eventsFired = [];

    const mutationObserver = new MutationObserver(
      (mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.addedNodes.length) {
            this.observeVisibility();
          }
        });
      },
    );

    mutationObserver.observe(this.$refs.debateHolder, { childList: true, subtree: true });

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const element = document.querySelector('[debate-id]');
            if (element) {
              const debateId = element.getAttribute('debate-id');
              const findIndex = this.eventsFired.findIndex((data) => String(data.id) === String(debateId));
              const findElement = this.eventsFired[findIndex]
              if (!findElement) {
                this.pollViewedEventFire(debateId);
                this.eventsFired.push({
                  id: debateId,
                  pollViewed: true
                })
              } else if (findElement && !findElement?.pollViewed) {
                this.pollViewedEventFire(debateId);
                this.eventsFired[findIndex].pollViewed = true;
              }
              this.observer.unobserve(element); // Stop observing after handling
            }
          }
        });
      },
      { threshold: 0.5 } // Trigger only when the element is fully visible
    );
  },
  methods: {
    async getDataFromEmbed() {
      const { globals, embedPlacementId } =
        this;
      if (!embedPlacementId) return;
      const { deviceId, userKey, pageUrl } = globals;
      const firstRequest = axios.get(`/collections/getCollectionByEmbedPlacement?pageUrl=${encodeURIComponent(pageUrl
      )}&embedPlacementId=${embedPlacementId}&deviceId=${deviceId}&uniqueUserId=${userKey}&categories=${encodeURIComponent(
        this.categories?.length > 0 ? this.categories.join(",") :
          window.sidedScriptPayload &&
            window.sidedScriptPayload.categories
            ? window.sidedScriptPayload.categories.join(",")
            : "",
      )}`)

      const secondRequest = axios.get(`/debate/getDebateByEmbedPlacement?pageUrl=${encodeURIComponent(pageUrl
      )}&embedPlacementId=${embedPlacementId}&slotNumber=${1}&deviceId=${deviceId}&uniqueUserId=${userKey}&categories=${encodeURIComponent(
        this.categories?.length > 0 ? this.categories.join(",") :
          window.sidedScriptPayload &&
            window.sidedScriptPayload.categories
            ? window.sidedScriptPayload.categories.join(",")
            : "",
      )}`)


      return Promise.all([firstRequest, secondRequest])
        .then(([firstResponse, secondResponse]) => {
          if (firstResponse.data?.data?.id) {
            this.sequenceId = parseInt(firstResponse.data.data.id);
            this.embedFor = "sequence";
          } else if (secondResponse.data?.data?.id) {
            this.debateDetailsFromEmbed = secondResponse.data;
            this.embedFor = "debate";
          }
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    },
    changeDebateFromHistory(previousDebate) {
      this.debate = previousDebate;
    },
    observeVisibility() {
      this.$nextTick(() => {
        const container = this.$refs.debateHolder;
        const items = container.querySelectorAll('[debate-id]');
        items.forEach((item) => {
          const debateId = item.getAttribute('debate-id');
          const alreadyObserved = this.eventsFired.some((data) => String(data.id) === String(debateId));
          if (!alreadyObserved) {
            this.observer.observe(item);
          }
        });
      });
    },
    cleanupObservers() {
      const items = this.$refs.debateHolder.querySelectorAll('[debate-id]');
      items.forEach((item) => this.observer.unobserve(item));
    },
    pollViewedEventFire(debateId) {
      this.fireEvent({
        debateId: debateId,
        eventType: "poll_viewed"
      })

      window.sidedAnalytics.logEvent("poll_viewed"); // eslint-disable-line
      this.fireEventGA("poll_viewed");
    },
    loadJs(src, callback = null, id = "") {
      var script = document.createElement("script");

      script.setAttribute("src", src);
      script.setAttribute("type", "text/javascript");
      script.setAttribute("async", true);

      if (id) {
        script.setAttribute("id", id);
      }

      document.head.appendChild(script);

      script.addEventListener("load", function () {
        if (callback) {
          callback();
        }
      });
    },
    async initData() {
      if (this.embedPlacementId) {
        await this.loadPlacementDetails();
      }
      if (this.sequenceId) {
        this.isFirstLoad = true;
        this.loadSequence();
      } else if (this.formId) {
        this.loadForm(this.formId);
      } else {
        this.loadUserInfo(() => this.loadDebate());
      }
    },
    loadSequence() {
      axios.get(`api/sequences/${this.sequenceId}`, { isNewAPI: true, params: { isDraft: 0 } }).then(({ data }) => {
        this.loading = false;
        if (data.status == 1) {
          this.collectionData = data.data;
          this.currentStepInCollection = this.collectionData.steps.slice(0, 1)[0];
          if (this.currentStepInCollection) {
            if (this.currentStepInCollection?.part?.partType !== "form") {
              this.debateId = this.currentStepInCollection.part.debate
                .id;
              this.currentBranchDetails = [];
              if (this.currentStepInCollection?.branches?.length > 0) {
                this.currentBranchDetails = this.currentStepInCollection.branches;
              }
              this.loadDebate();
            } else {
              this.loadForm(this.currentStepInCollection.part.form
                .id)
            }
          }
        }
      });
    },
    onFormSubmit(formCaption) {
      if (this.shouldBreakSequence) {
        this.loadNextFeedItem(this.sequenceId);
        return;
      }
      if (this.sequenceId) {
        this.shouldBreakSequence = false;
        if (this.currentBranchDetails.length > 0) {
          let shouldWeLoadBranch = false;
          this.currentBranchDetails.forEach((branch) => {
            if (branch.branchOption === formCaption) {
              if (branch.nextStep.part?.partType !== "form") {
                this.debateId = branch.nextStep.part.debate.id
                this.loadDebate();
              } else {
                this.loadForm(branch.nextStep.part.form.id)
              }
              this.currentBranchDetails = branch.nextStep.branches;
              this.nextStepIdInCollectionAfterBranch = "";
              if (branch.nextStep?.andThen?.nextStepId) {
                this.nextStepIdInCollectionAfterBranch = branch.nextStep.andThen.nextStepId;
              } else if (!branch.nextStep.andThen && branch.nextStep?.branches.length === 0) {
                this.shouldBreakSequence = true;
              }
              shouldWeLoadBranch = true;
            }
          })
          if (this.shouldBreakSequence) {
            this.loadNextFeedItem(this.sequenceId);
            return;
          }
          if (!shouldWeLoadBranch) {
            const findIndex = this.collectionData.steps.findIndex((colData) => colData.id === this.currentStepInCollection.id);
            if (findIndex > -1) {
              this.currentStepInCollection = this.collectionData.steps[findIndex + 1];
              if (this.currentStepInCollection?.part?.partType !== "form") {
                this.debateId = this.currentStepInCollection.part.debate
                  .id;
                this.currentBranchDetails = [];
                if (this.currentStepInCollection?.branches?.length > 0) {
                  this.currentBranchDetails = this.currentStepInCollection.branches;
                }
                this.loadDebate();
              } else {
                this.loadForm(this.currentStepInCollection.part.form
                  .id)
              }
            }
          }
        } else if (this.nextStepIdInCollectionAfterBranch) {
          const findIndex = this.collectionData.steps.findIndex((colData) => colData.id === this.nextStepIdInCollectionAfterBranch);
          this.nextStepIdInCollectionAfterBranch = "";
          if (findIndex > -1) {
            this.currentStepInCollection = this.collectionData.steps[findIndex];
            if (this.currentStepInCollection) {
              if (this.currentStepInCollection?.part?.partType !== "form") {
                this.debateId = this.currentStepInCollection.part.debate
                  .id;
                this.currentBranchDetails = [];
                if (this.currentStepInCollection?.branches?.length > 0) {
                  this.currentBranchDetails = this.currentStepInCollection.branches;
                }
                this.loadDebate();
              } else {
                this.loadForm(this.currentStepInCollection.part.form
                  .id)
              }
            }

          }
        } else {
          if (this.shouldBreakSequence) {
            this.loadNextFeedItem(this.sequenceId);
            return;
          }
          const findIndex = this.collectionData.steps.findIndex((colData) => colData.id === this.currentStepInCollection.id);
          if (findIndex > -1) {
            this.currentStepInCollection = this.collectionData.steps[findIndex + 1];
            if (this.currentStepInCollection) {
              if (this.currentStepInCollection?.part?.partType !== "form") {
                this.debateId = this.currentStepInCollection.part.debate
                  .id;
                this.currentBranchDetails = [];
                if (this.currentStepInCollection?.branches?.length > 0) {
                  this.currentBranchDetails = this.currentStepInCollection.branches;
                }
                this.loadDebate();
              } else {
                this.loadForm(this.currentStepInCollection.part.form
                  .id)
              }
            } else {
              this.loadNextFeedItem(this.sequenceId);
            }

          }
        }
      }

    },
    findDeepDebates(array, idToSearch) {
      const results = [];

      // Helper function to recursively search for `step.id`
      function searchDeep(obj) {
        if (typeof obj !== "object" || obj === null) return false;

        // Check if the current object contains `step.id` matching `idToSearch`
        if (obj.step?.id === idToSearch) {
          return true;
        }

        // Recursively search inside objects or arrays
        for (const key in obj) {
          if (typeof obj[key] === "object" && searchDeep(obj[key])) {
            return true;
          }
        }

        return false;
      }

      // Filter array elements based on the recursive search
      for (const item of array) {
        if (searchDeep(item)) {
          results.push(item);
        }
      }

      return results;
    },
    onCloseSidePanel() {
      this.sidePanelVisible = false;

      if (window.location.host === "dodgerblue.com") {
        document.querySelector("#secondary .sidebar").removeAttribute("style");
      } else if (window.location.host === "www.retroheadz.com") {
        document.querySelector(".single-content").removeAttribute("style");
      } else if (window.location.host === "truthpress.com") {
        document
          .querySelector(".theiaStickySidebar")
          .classList.remove("reset-fixed-translate");
      }
    },
    loadNetworkDebates() {
      if (this.sidePanelTab === "feed") {
        this.setSidePanelTab("standard");
      } else {
        this.setSidePanelTab("feed");
        this.networkDebates = [];
        this.networkDebatesPage = 1;
        this.allNetworkDebatesLoaded = false;
        this.loadNetworkDebatesPage();
        window.sidedAnalytics.logEvent("open_sidepanel_feed", {
          pagename: this.debate.thesis,
        }); // eslint-disable-line
        this.fireEventGA("open_sidepanel_feed", {
          pagename: this.debate.thesis,
        });
      }
    },
    loadNetworkDebatesPage() {
      this.loadMore = true;

      axios
        .get(
          `/feeds?filter=ALL&pageNumber=${this.networkDebatesPage}&perPage=10&deviceId=${this.globals.deviceId}&clientId=${this.debate.clientId}&categories=${encodeURIComponent(
            this.categories?.length > 0 ? this.categories.join(",") :
              window.sidedScriptPayload &&
                window.sidedScriptPayload.categories
                ? window.sidedScriptPayload.categories.join(",")
                : "",
          )}&overridePollVisibility=${this.overridePollVisibility || ""}`,
        )
        .then(({ data }) => {
          const newDebates = data.data.map((debate) => new Debate(debate));
          this.networkDebates = (
            this.networkDebatesPage > 1 ? this.networkDebates : []
          ).concat(newDebates);
          this.loadMore = false;

          if (!data.data.length) {
            this.allNetworkDebatesLoaded = true;
          }

          setTimeout(() => window.OBR.extern.researchWidget(), 500);
        });
    },
    onSidePanelScroll: function ({ target }) {
      if (
        this.sidePanelTab === "feed" &&
        !this.feedDebate &&
        !this.loadMore &&
        !this.allNetworkDebatesLoaded
      ) {
        if (
          target.scrollTop >
          target.scrollHeight - target.offsetHeight - 100
        ) {
          this.networkDebatesPage = this.networkDebatesPage + 1;
          this.loadNetworkDebatesPage();
        }
      }
    },
    setGlobals: function (key, value) {
      this.globals[key] = value;
    },
    setCookie(cookieName, cookieValue, useLocalStorage = false) {
      if (
        [
          this.globals.refCookieName,
          this.globals.accessTokenCookieName,
          this.globals.refreshTokenCookieName,
          this.globals.authTokenKey,
        ].indexOf(cookieName) !== -1 ||
        useLocalStorage
      ) {
        this.setData(cookieName, cookieValue);
      } else {
        document.cookie =
          cookieName + "=" + cookieValue + "; expires=31 Dec 2030 12:00:00 UTC";
      }
    },
    removeCookie(cookieName, useLocalStorage = false) {
      if (
        [
          this.globals.refCookieName,
          this.globals.accessTokenCookieName,
          this.globals.refreshTokenCookieName,
          this.globals.authTokenKey,
        ].indexOf(cookieName) !== -1 ||
        useLocalStorage
      ) {
        this.removeData(cookieName);
      } else {
        document.cookie = cookieName + "=; expires=31 Dec 2020 12:00:00 UTC";
      }
    },
    getCookie(cookieName, useLocalStorage = false) {
      if (
        [
          this.globals.refCookieName,
          this.globals.accessTokenCookieName,
          this.globals.refreshTokenCookieName,
          this.globals.authTokenKey,
        ].indexOf(cookieName) !== -1 ||
        useLocalStorage
      ) {
        const item = this.getData(cookieName);

        return item ? item : "";
      } else {
        const cookie = document.cookie
          .split("; ")
          .filter((cookie) => cookie.indexOf(cookieName) !== -1)
          .map((cookie) => cookie.replace(cookieName + "=", ""))
          .find(() => true);

        return cookie ? cookie : "";
      }
    },
    setData(key, value) {
      try {
        localStorage.setItem(key, value);
      } catch (e) {
        console.log(e);
      }
    },
    removeData(key) {
      try {
        localStorage.removeItem(key);
      } catch (e) {
        console.log(e);
      }
    },
    getData(key) {
      try {
        return localStorage.getItem(key);
      } catch (e) {
        console.log(e);
      }

      return null;
    },
    generateAuthToken(callback) {
      axios.post("/auth/authToken").then((response) => {
        this.setGlobals("authToken", response.data.token);
        this.setCookie(this.globals.authTokenKey, response.data.token);
        callback();
      });
    },
    loadUserInfo(callback) {
      if (this.globals.userKey) {
        axios
          .get(
            `/user/${this.globals.userKey}?deviceId=${this.globals.deviceId}`,
          )
          .then(
            (response) => {
              var data = response.data.data;
              this.globals.userInfo = data;

              if (!data.contactVerified || !data.username) {
                this.initSignup();
                this.globals.userInfoNeeds = !data.contactVerified
                  ? "verify"
                  : !data.username
                    ? "username"
                    : "";
              }

              this.executePendingAction();
              callback();
            },
            (error) => {
              if (error.response.status === 490) {
                this.generateAuthToken(() =>
                  this.loadUserInfo(() => this.loadDebate()),
                );
              }
            },
          );
      } else {
        callback();
      }
    },
    loadTpdAdsConfig() {
      this.loadJs(
        "https://cdn.tpdads.com/configs/" +
        window.location.host
          .replace("www.", "")
          .replace("get.", "")
          .replace("development22.", "")
          .replace("development23.", "")
          .split(".")[0] +
        ".js",
      );
      this.loadJs("https://securepubads.g.doubleclick.net/tag/js/gpt.js");
    },
    loadOutbrain() {
      this.adsOutbrainLoaded = true;
      setTimeout(() => {
        this.loadJs("https://widgets.outbrain.com/outbrain.js");
      }, 1000);
    },
    loadTaboola() {
      // nothing for now
    },
    loadDataBlocks() {
      setTimeout(() => {
        if (!document.querySelector("#sided-datablocks-script")) {
          this.loadJs(
            "https://cdn.sided.co/embed-assets/datablocks.js",
            null,
            "sided-datablocks-script",
          );
        }
      }, 1000);
    },
    loadAditude() {
      this.adsAditudeLoaded = true;
      if (!window.tude && !window.aditudeScriptExecuted) {
        window.aditudeScriptExecuted = true;
        window.aditudeAdCounter = 1;
        this.loadJs("https://dn0qt3r0xannq.cloudfront.net/sided-vhykaavXuO/sided-longform/prebid-load.js", () => {
          console.log("prebid-load.js loaded");
          this.adsAditude = true;
        })
      } else if (window.aditudeScriptExecuted && window.aditudeAdCounter) {
        this.adsAditude = true;
      }
    },
    loadForm(id) {
      axios.get(`/forms/${id}`).then(({ data }) => {
        setTimeout(() => {
          this.debate = null;
          this.debateId = null;
        }, 800)
        this.form = data.data;
      }).finally(() => {
        this.loading = false;
      });
    },
    loadDebate(callback = null, justRefresh = false, specificDebateId = 0) {
      const { currentPage, network, globals, debateId, debateDetailsFromEmbed } = this;
      const { deviceId, userKey } = globals;

      // If debateDetailsFromEmbed is available, process it directly
      if (debateDetailsFromEmbed) {
        const debateData = JSON.parse(JSON.stringify(debateDetailsFromEmbed));
        this.debateDetailsFromEmbed = null;
        this.processDebateData(debateData, callback, justRefresh);
        return;
      }

      // Construct the URL for the API call
      const url = specificDebateId
        ? `/debate/${specificDebateId}?deviceId=${deviceId}&uniqueUserId=${userKey}${this.sequenceId ? "&sequenceId=" + this.sequenceId : ""}`
        : this.network
          ? `/feeds?filter=ALL&pageNumber=${currentPage}&perPage=10&deviceId=${deviceId}&clientId=${network}&categories=${encodeURIComponent(
            this.categories?.length > 0 ? this.categories.join(",") :
              window.sidedScriptPayload?.categories?.join(",") || "",
          )}&overridePollVisibility=${this.overridePollVisibility || ""}`
          : `/debate/${debateId}?deviceId=${deviceId}&uniqueUserId=${userKey}${this.sequenceId ? "&sequenceId=" + this.sequenceId : ""}`;

      // Make the API call
      axios.get(url).then(
        (response) => {
          this.processDebateData(response.data, callback, justRefresh);
        },
        (error) => {
          if (error.response.status === 490) {
            this.generateAuthToken(() =>
              this.loadUserInfo(() => this.loadDebate(callback, justRefresh, specificDebateId)),
            );
          } else {
            this.debateNotFound = true;
          }
        },
      );
    },
    async processDebateData(data, callback) {
      this.loading = false;

      if (this.form) {
        this.form = null;
      }

      const debateData = data.data;
      const debate = new Debate(Array.isArray(debateData) ? debateData[0] : debateData);

      if (!debate || !debate.id) {
        this.debateNotFound = true;
        return;
      }

      if (!this.networkIdentity) {

        const response = await axios
          .get(`/admin/client/header/${debate.clientId}`);

        if (response.data) {
          const clientInfo = data.data;
          this.networkIdentity = clientInfo;
          if (clientInfo.isSpanish) {
            import("./language-support").then(({ ES }) => {
              this.$i18n.setLocaleMessage("es", ES);
              this.$i18n.locale = "es";
            });
          }
        }
      }

      this.initDebate(debate, debateData, false, data.debateClient);


      if (this.isInfinite() && this.debateNextList.length === 0) {
        const { deviceId, userKey } = this.globals;
        axios
          .get(
            `api/embed/feed?deviceId=${deviceId}&uniqueUserId=${userKey}&clientId=${debate.clientId}&exclude=${debate.id}&isQuiz=${debate.isQuiz}${debate.categories?.length
              ? `&categories=${debate.categories.map((category) => category.id).join(",")}`
              : ""
            }&embedPlacementId=${this.embedPlacementId}&pageUrl=${this.globals.pageUrl}`, { isNewAPI: true }
          )
          .then(({ data }) => {
            this.debateNextList = data.data;
          });
      }

      if (debate.embedPlacementInfo) {
        this.handleEmbedPlacementInfo(debate.embedPlacementInfo);
      }

      if (callback) {
        this.debateHistory = [];
        callback();
      }
    },

    // Helper method to handle embed placement info
    handleEmbedPlacementInfo(embedPlacementInfo) {
      this.adsHidden = String(this.debateClient.advertising) === "0" || this.overrideAds === "hidden" || this.overrideAds === "false" || embedPlacementInfo.ads === "hidden" || embedPlacementInfo.ads === "false";
      if (embedPlacementInfo.advertisingSource === "publisher_desk") {
        this.loadTpdAdsConfig();
      } else if (embedPlacementInfo.advertisingSource === "outbrain" && !this.adsOutbrainLoaded) {
        this.loadOutbrain();
      } else if (embedPlacementInfo.advertisingSource === "taboola") {
        this.loadTaboola();
      } else if (embedPlacementInfo.advertisingSource === "datablocks") {
        this.loadDataBlocks();
      } else if (embedPlacementInfo.advertisingSource === "aditude" && !this.adsAditudeLoaded) {
        this.loadAditude();
      }
    },
    loadNextItem(item, callback = null) {
      if (this.debateNextList.length === 0) return;
      if (
        item.contentTypeId
      ) {
        if (item?.contentType === "Sequence") {
          this.debateId = 0;
          this.sequenceId = item.contentTypeId;
          this.loadSequence();
          return;
        }
        if (item?.contentType === "Form") {
          setTimeout(() => this.loadForm(item.contentTypeId), 4000);
        } else {
          this.debateId = item.contentTypeId;
          if (callback) {
            callback();
          }
          this.loadDebate();
        }
      }

    },
    showNextDebate() {
      this.votingStarted = false;
      this.requireEmailWasClosed = false;
      if (this.nextDebate) {
        this.debate = this.nextDebate;
        this.debateHistory.push(this.nextDebate);
        this.nextDebate = null;
      }

    },
    initDebate(debate, debatesList = [], reInitAd = true, networkData = null, loadHistory) {
      if (!debate) return;
      if (networkData) {
        this.debateClient = networkData;
        window.sidedDataBlocksID = this.debateClient.datablocksSid;
        this.sidebarAds = this.debateClient.sidebarAds;

        if (this.sidebarAds && window.loadSidedJs) {
          this.loadOutbrain();
        }
      }

      if (reInitAd) {
        const pdAdPlaceholder = this.$refs.debateHolder.querySelector(
          '[id^="dsk-sided-ad-a"]',
        );
        /*const outbrainAdPlaceholder = this.$refs.debateHolder.querySelector(
          ".ads-holder.ads-outbrain .OUTBRAIN",
        );*/

        if (pdAdPlaceholder) {
          this.$refs.debateHolder.querySelector(
            '[id^="dsk-sided-ad-a"]',
          ).parentElement.innerHTML = '<div id="dsk-sided-ad-a"></div>';
          window.dispatchEvent(
            new CustomEvent("sided:init", {
              detail: this.$refs.debateHolder.parentElement.parentElement,
            }),
          );
        }

        /*if (outbrainAdPlaceholder) {
          outbrainAdPlaceholder.innerHTML = "";
          setTimeout(() => window.OBR.extern.refreshWidget(), 500);
        }*/
      }
      if (!this.embedPlacementId && debate.embedPlacementInfo) {
        const ads = this.overrideAds
          ? this.overrideAds
          : debate.embedPlacementInfo.ads;

        this.adsHidden = String(this.debateClient.advertising) === "0" || ads === "hidden" || ads === "false";
        this.adsAdSense = ads === "adsense";
        this.adsRevContent =
          ads === "rev_content" ||
          debate.embedPlacementInfo.advertisingSource === "rev_content";
        this.adsOutbrain =
          ads === "outbrain" ||
          debate.embedPlacementInfo.advertisingSource === "outbrain";
        this.adsTaboola =
          ads === "taboola" ||
          debate.embedPlacementInfo.advertisingSource === "taboola";
        this.adsDataBlocks =
          ads === "datablocks" ||
          debate.embedPlacementInfo.advertisingSource === "datablocks";
        this.isPoll = this.overrideComments
          ? this.overrideComments === "yes"
          : ["poll", "conversion_poll"].indexOf(
            debate.embedPlacementInfo.embedType.trim(),
          ) !== -1;
        this.isConversion =
          ["conversion_poll", "conversion_poll_comments"].indexOf(
            debate.embedPlacementInfo.embedType.trim(),
          ) !== -1;
        this.showTopComment = debate.embedPlacementInfo.topComment;
        this.adCode = debate.embedPlacementInfo.adCode;
        this.adCodeMobile = debate.embedPlacementInfo.adCodeMobile;

        if (!this.adsHidden && !this.overrideAdPosition) {
          this.adPosition = debate.embedPlacementInfo.adPosition;
        }

        this.requireEmail = debate.embedPlacementInfo.requireEmail;

        if ([-1, 1, 2].indexOf(debate.requireEmail) !== -1) {
          this.requireEmail =
            debate.requireEmail === -1 ? 0 : debate.requireEmail;
        }
      } else {
        this.requireEmail = !!debate.requireEmail;

        if (
          this.embedPlacementData &&
          this.embedPlacementData.requireEmail !== this.requireEmail
        ) {
          this.requireEmail = this.embedPlacementData.requireEmail;
        }

        if (this.overrideAds === "hidden") {
          this.adsHidden = true;
        }
      }

      this.isQuiz = debate.isQuiz;

      if (!this.debate || loadHistory) {
        this.debate = debate;
        const indexOfHistory = this.debateHistory.findIndex((deb) => debate.id === deb.id);
        if (indexOfHistory === -1) {
          this.debateHistory.push(debate);
        }
      } else {
        this.nextDebate = debate;
      }



      if (this.network) {
        var debates = [];

        for (let i in debatesList) {
          debates.push(new Debate(debatesList[i]));
        }

        this.debates = debates;
      } else {
        this.loadFeed();
        this.updateSession();
      }

      if (
        this.debateClient &&
        !this.debateClient.advertising &&
        !this.adsHidden
      ) {
        this.adsHidden = true;
      }

      if (!this.adsLoaded && !this.adsHidden) {
        this.adsLoaded = true;

        if (this.adsAdSense) {
          // googletag.cmd.push(function() {
          //   googletag.defineSlot('/21866141888/embed_desktop', [300, 250], 'div-gpt-ad-1619577812682-0').addService(googletag.pubads())
          //   googletag.defineSlot('/21866141888/embed_mobile', [[320, 100], [320, 50], [300, 50], [300, 100], [300, 75]], 'div-gpt-ad-1619577431738-0').addService(googletag.pubads())
          //   googletag.pubads().enableSingleRequest()
          //   googletag.pubads().setTargeting('user_profile', [self.debate.user.id]).setTargeting('category', [self.debate.categories[0].slug]).setTargeting('network', [self.debate.siteDomain])
          //   googletag.enableServices()
          // })
          // setTimeout(() => {
          //   googletag.cmd.push(() => {
          //     googletag.display(this.isMobile() ? 'div-gpt-ad-1619577431738-0' : 'div-gpt-ad-1619577812682-0')
          //   })
          // }, 2000)
        } else {
          this.dispatchEvent();
        }
      }

      if (this.adsRevContent) {
        setTimeout(
          () => this.loadJs("https://assets.revcontent.com/master/delivery.js"),
          500,
        );
      }
      this.pollImpressionViewedEventFired = false;
    },
    loadNextPage() {
      this.loadMore = true;
      this.currentPage = this.currentPage + 1;

      const url = `/feeds?filter=ALL&pageNumber=${this.currentPage}&perPage=10&deviceId=${this.globals.deviceId}&clientId=${this.network}&categories=${encodeURIComponent(this.categories?.length > 0 ? this.categories.join(",") : window.sidedScriptPayload?.categories?.join(",") || "")}&overridePollVisibility=${this.overridePollVisibility || ""}`;

      axios.get(url).then((response) => {
        const data = response.data.data;
        this.loadMore = false;

        for (let i in data) {
          this.debates.push(new Debate(data[i]));
        }

        if (!data.length) {
          this.allDebatesLoaded = true;
        }
      });
    },
    loadPlacementDetails() {
      return axios
        .get(
          `/embed/getEmbedPlacementById/${this.embedPlacementId}?clientId=${this.clientId}`,
        )
        .then(
          (response) => {
            const placementData = response.data.data;

            if (!placementData) {
              this.debateNotFound = true;
              return;
            }

            const ads = this.overrideAds ? this.overrideAds : placementData.ads;
            this.embedPlacementData = placementData;
            this.adsHidden = ads === "hidden" || ads === "false";
            this.adsAdSense = ads === "adsense";
            this.adsRevContent =
              ads === "rev_content" ||
              placementData.advertisingSource === "rev_content";
            this.adsOutbrain =
              ads === "outbrain" ||
              placementData.advertisingSource === "outbrain";
            this.adsTaboola =
              ads === "taboola" ||
              placementData.advertisingSource === "taboola";
            this.adsDataBlocks =
              ads === "datablocks" ||
              placementData.advertisingSource === "datablocks";
            this.isPoll = this.overrideComments
              ? this.overrideComments === "yes"
              : ["poll", "conversion_poll"].indexOf(
                placementData.embedType.trim(),
              ) !== -1;
            this.isConversion =
              ["conversion_poll", "conversion_poll_comments"].indexOf(
                placementData.embedType.trim(),
              ) !== -1;
            this.showTopComment = placementData.topComment;
            this.adCode = placementData.adCode;
            this.adCodeMobile = placementData.adCodeMobile;

            if (!this.adsHidden && !this.overrideAdPosition) {
              this.adPosition = placementData.adPosition;
            }

            if (placementData.advertisingSource === "publisher_desk") {
              this.loadTpdAdsConfig();
            } else if (
              placementData.advertisingSource === "outbrain" &&
              !this.adsOutbrainLoaded
            ) {
              this.loadOutbrain();
            } else if (placementData.advertisingSource === "taboola") {
              this.loadTaboola();
            } else if (placementData.advertisingSource === "datablocks") {
              this.loadDataBlocks();
            } else if (placementData.advertisingSource === "aditude" && !this.adsAditudeLoaded) {
              this.loadAditude();
            }

          },
          (error) => {
            if (error.response.status === 490) {
              this.generateAuthToken(async () => {
                await this.loadPlacementDetails();
                this.initData()
              });
            } else {
              this.debateNotFound = true;
            }
          },
        );
    },
    loadFeed() {
      axios
        .get(`/argument/getSingleFeedList?debateId=${this.debate.id}`)
        .then((response) => {

          this.arguments = response.data.data.map(
            (argument) => new Argument(argument),
          );
          const findIndex = this.eventsFired.findIndex((data) => String(data.id) === String(this.debate.id));
          const findElement = this.eventsFired[findIndex]
          if (!findElement) {
            this.fireEvent({
              debateId: this.debate.id,
              eventType: "poll_impression"
            })
            this.eventsFired.push({
              id: this.debate.id,
              pollImpression: true
            })
          }
          else if (!findElement?.pollImpression) {
            this.fireEvent({
              debateId: this.debate.id,
              eventType: "poll_impression"
            })
            this.eventsFired[findIndex].pollImpression = true;
          }

        });
    },
    updateSession() {
      setTimeout(() => {
        const metas = document.querySelectorAll("meta");
        let publishedDate = "";
        let pageTags =
          this.categories?.length > 0 ? this.categories.join(",") : window.sidedScriptPayload && window.sidedScriptPayload.categories
            ? window.sidedScriptPayload.categories.join(",")
            : "";

        metas.forEach((meta) => {
          if (meta.getAttribute("property") === "article:published_time") {
            publishedDate = meta.content;
          }

          if (meta.getAttribute("property") === "article:category") {
            pageTags = meta.content;
          }

          if (meta.content && meta.content.indexOf("articleCategory") !== -1) {
            pageTags = meta.content.replaceAll("articleCategory=", "").trim();
          }
        });

        const payload = {
          fingerprintId: this.globals.deviceId,
          scrollDepth: 0,
          clientId: this.clientId || this.debate.clientId,
        };

        if (this.globals.userInfo) {
          payload.userId = this.globals.userInfo.id;
        }

        payload.domain = window.location.host.replace("www.", "");
        payload.pageUrl = this.globals.pageUrl;
        payload.pageTitle = document.title;
        payload.publishedDate = publishedDate;
        payload.pageTags = pageTags;
        payload.includeAnalytics = true;

        // embedDomainId
        if (this.embedPlacementId) {
          payload.embedPlacementId = this.embedPlacementId;
        }

        if (this.updateSessionWasDone) {
          return;
        }

        this.updateSessionWasDone = true;

        axios.post("/embed/updateSession", payload);

        window.sidedAnalytics.logEvent("poll_impression"); // eslint-disable-line
        this.fireEventGA("poll_impression");
      }, 1000);
    },
    onLogOut() {
      this.userIsVerified = false;
      this.removeCookie(this.globals.verifiedUserCookieName, true);
      this.removeCookie(this.globals.verifiedUserIdCookieName, true);

      this.sidePanelTab = "standard";
      this.globals.userKey = "";
      this.globals.accessToken = "";
      this.globals.refreshToken = "";
      this.removeCookie(this.globals.refCookieName);
      this.removeCookie(this.globals.accessTokenCookieName);
      this.removeCookie(this.globals.refreshTokenCookieName);
      this.globals.userInfo = null;
    },
    copyToClipboard(text) {
      const element = document.createElement("textarea");
      element.value = text;
      document.body.appendChild(element);
      element.select();
      document.execCommand("copy");
      document.body.removeChild(element);
    },
    onVote(debate, side) {
      debate.votedSideId = side.id;
      debate.votes++;

      for (let i in debate.sides) {
        if (debate.sides[i].id === side.id) {
          debate.sides[i].votes++;
        }
      }

      const mostVoted = Math.max(...debate.sides.map((side) => side.votes));

      for (let i in debate.sides) {
        const side = debate.sides[i];
        let percent = ((side.votes / debate.votes) * 100).toFixed(1);
        percent = isNaN(parseInt(percent)) ? "0" : percent;

        debate.sides[i].percent = percent;
        debate.sides[i].isMostVoted = mostVoted === debate.sides[i].votes;
      }
      const params = {
        type: "VOTE",
        debateId: debate.id,
        deviceId: this.globals.deviceId,
        embedDeviceId: this.globals.deviceId,
        sideId: side.id,
        domain: debate.siteDomain,
        pageUrl: this.globals.pageUrl,
      }
      if (this.globals.userKey) {
        params.userId = this.globals.userKey;
      }
      if (this.sequenceId) {
        params.sequenceId = this.sequenceId;
      }
      this.votingStarted = true;
      axios
        .post("/debate/vote", params)
        .then(() => {
          const payload = {
            debateId: debate.id,
            sideId: side.id,
            fingerprintId: this.globals.deviceId,
            eventType: "vote",
          };

          payload.clientId = this.clientId || this.debate.clientId;

          this.fireEvent(payload);
          window.sidedAnalytics.logEvent("vote", {
            debate: this.debate.thesis,
          }); // eslint-disable-line
          this.fireEventGA("vote", { debate: this.debate.thesis });

          if (this.isInfinite()) {
            window.sidedAnalytics.logEvent(
              `vote_${this.debateHistory.length}`,
              {
                debate: this.debate.thesis,
              },
            ); // eslint-disable-line

            this.fireEventGA(`vote_${this.debateHistory.length}`, {
              debate: this.debate.thesis,
            });
          }
          if (Number(this.embedPlacementData?.redirectEmbedVotesToWebPlatform) === 1) {
            if (this.isMobile()) {
              window.location.href = `${this.debateClient.siteUrl}/${this.debate.user.username}/${this.debate.slug}`;
            } else {
              window.open(
                `${this.debateClient.siteUrl}/${this.debate.user.username}/${this.debate.slug}`,
                "_blank",
              );
            }
          }
        });
      if (this.shouldBreakSequence) {
        this.loadNextFeedItem(this.sequenceId)
        return;
      }
      if (this.sequenceId) {
        this.shouldBreakSequence = false;
        if (this.currentBranchDetails.length > 0) {
          let shouldWeLoadBranch = false;
          this.currentBranchDetails.forEach((branch) => {
            if (branch.branchOption === side.text) {
              if (branch.nextStep.part?.partType !== "form") {
                this.debateId = branch.nextStep.part.debate.id
                this.loadDebate();
              } else {
                this.loadForm(branch.nextStep.part.form.id)
              }
              this.currentBranchDetails = branch.nextStep.branches;
              this.nextStepIdInCollectionAfterBranch = "";
              if (branch.nextStep?.andThen?.nextStepId) {
                this.nextStepIdInCollectionAfterBranch = branch.nextStep.andThen.nextStepId;
              } else if (!branch.nextStep.andThen && branch.nextStep?.branches.length === 0) {
                this.shouldBreakSequence = true;
              }
              shouldWeLoadBranch = true;
            }
          })
          if (this.shouldBreakSequence) {
            this.loadNextFeedItem(this.sequenceId);
            return;
          }
          if (!shouldWeLoadBranch) {
            const findIndex = this.collectionData.steps.findIndex((colData) => colData.id === this.currentStepInCollection.id);
            if (findIndex > -1) {
              this.currentStepInCollection = this.collectionData.steps[findIndex + 1];
              if (this.currentStepInCollection?.part?.partType !== "form") {
                this.debateId = this.currentStepInCollection.part.debate
                  .id;
                this.currentBranchDetails = [];
                if (this.currentStepInCollection?.branches?.length > 0) {
                  this.currentBranchDetails = this.currentStepInCollection.branches;
                }
                this.loadDebate();
              } else {
                this.loadForm(this.currentStepInCollection.part.form
                  .id)
              }
            }
          }
        } else if (this.nextStepIdInCollectionAfterBranch) {

          const findIndex = this.collectionData.steps.findIndex((colData) => colData.id === this.nextStepIdInCollectionAfterBranch);
          this.nextStepIdInCollectionAfterBranch = "";
          if (findIndex > -1) {
            this.currentStepInCollection = this.collectionData.steps[findIndex];
            if (this.currentStepInCollection) {
              if (this.currentStepInCollection?.part?.partType !== "form") {
                this.debateId = this.currentStepInCollection.part.debate
                  .id;
                this.currentBranchDetails = [];
                if (this.currentStepInCollection?.branches?.length > 0) {
                  this.currentBranchDetails = this.currentStepInCollection.branches;
                }
                this.loadDebate();
              } else {
                this.loadForm(this.currentStepInCollection.part.form
                  .id)
              }
            }

          }
        } else {
          if (this.shouldBreakSequence) {
            this.loadNextFeedItem(this.sequenceId);
            return;
          }
          const findIndex = this.collectionData.steps.findIndex((colData) => colData.id === this.currentStepInCollection.id);
          if (findIndex > -1) {
            this.currentStepInCollection = this.collectionData.steps[findIndex + 1];
            if (this.currentStepInCollection) {
              if (this.currentStepInCollection?.part?.partType !== "form") {
                this.debateId = this.currentStepInCollection.part.debate
                  .id;
                this.currentBranchDetails = [];
                if (this.currentStepInCollection?.branches?.length > 0) {
                  this.currentBranchDetails = this.currentStepInCollection.branches;
                }
                this.loadDebate();
              } else {
                this.loadForm(this.currentStepInCollection.part.form
                  .id)
              }
            } else {
              this.loadNextFeedItem(this.sequenceId)
            }

          }
        }
      } else {
        this.loadNextFeedItem(debate.id)
      }
    },
    loadNextFeedItem(contentId) {
      if (this.isInfinite() || this.form) {
        if (this.debateHistory.length === 1 || this.isFirstLoad) {

          this.isFirstLoad = false;
          if (this.debateNextList.length > 0) {
            this.shouldBreakSequence = false;
            this.currentBranchDetails = []
            this.nextStepIdInCollectionAfterBranch = "";
            this.collectionData = {}
            this.currentStepInCollection = null
            this.sequenceId = null;
            // this.votingStarted = true;
            const nextItem = this.debateNextList[0];
            if (nextItem?.contentType === "Sequence") {
              this.sequenceId = nextItem.contentTypeId;
              this.loadSequence();
            } else {
              this.debateId = nextItem.contentTypeId;
              this.loadDebate();
            }
          }
        } else {
          const currentDebateIndex = this.debateNextList.findIndex((next) => {
            return next.contentTypeId == contentId
          });

          const nextItem =
            this.debateNextList[currentDebateIndex + 1] || {};

          if (
            nextItem?.contentTypeId
          ) {
            if (nextItem?.contentType === "Sequence") {
              this.sequenceId = nextItem.contentTypeId;
              this.loadSequence();
            } else {
              this.shouldBreakSequence = false;
              this.currentBranchDetails = []
              this.nextStepIdInCollectionAfterBranch = "";
              this.collectionData = {}
              this.currentStepInCollection = null
              this.sequenceId = null;
              this.debateId = nextItem.contentTypeId;
              this.loadDebate();
            }
          }
        }

      }

    },
    onBackToTop() {
      document.querySelector(".side-panel-wrapper").scrollTo(0, 0);
    },
    getOutbrainAdId() {
      if (this.embedPlacementData?.placementName === "Sidebar") {
        return this.isMobile() ? "MB_1" : "SB_1";
      }

      return this.isMobile() ? "MB_1" : "AR_5";
    },
    isMobile() {
      return (
        navigator.userAgent.toLowerCase().indexOf("mobile") !== -1 ||
        window.innerWidth < 480
      );
    },
    isInfinite() {
      return this.networkIdentity?.isMultiple && !this.overrideMultiple;
    },
    registerConversionEvent() {
      axios.post("/embed/registerConversionEvent", {
        debateId: this.debate.id,
        userId: this.globals.userKey,
        fingerprintId: this.globals.deviceId,
        eventSourceId: window.sidedEmbedDomainPageId,
      });
    },
    executePendingAction() {
      if (this.globals.pendingAction !== "") {
        if (this.globals.pendingAction === "likeArgument") {
          this.onLikeArgument("like", this.globals.pendingActionData);
        } else if (this.globals.pendingAction === "dislikeArgument") {
          this.onLikeArgument("dislike", this.globals.pendingActionData);
        } else if (this.globals.pendingAction === "likeComment") {
          this.onLikeComment("like", this.globals.pendingActionData);
        } else if (this.globals.pendingAction === "dislikeComment") {
          this.onLikeComment("dislike", this.globals.pendingActionData);
        }

        this.globals.pendingAction = "";
        this.globals.pendingActionData = null;
      }
    },
    onLikeArgument(type, argument) {
      if (!this.globals.userInfo) {
        this.initLogin();
        this.globals.pendingAction =
          type === "like" ? "likeArgument" : "dislikeArgument";
        this.globals.pendingActionData = argument;
      } else {
        if (type === "like") {
          argument.isLiked = !argument.isLiked;

          if (argument.isLiked) {
            argument.likesCount = argument.likesCount + 1;
          } else {
            argument.likesCount = argument.likesCount - 1;
          }

          if (argument.isDisliked) {
            argument.isDisliked = false;
            argument.dislikesCount = argument.dislikesCount - 1;
          }

          this.fireEvent({
            debateId: this.debate.id,
            userId: this.globals.userKey,
            fingerprintId: this.globals.deviceId,
            eventType: "like_argument",
          });
        } else {
          argument.isDisliked = !argument.isDisliked;

          if (argument.isDisliked) {
            argument.dislikesCount = argument.dislikesCount + 1;
          } else {
            argument.dislikesCount = argument.dislikesCount - 1;
          }

          if (argument.isLiked) {
            argument.isLiked = false;
            argument.likesCount = argument.likesCount - 1;
          }
        }

        axios
          .post("/argument/like", {
            type: type,
            debateId: this.debate.id,
            argumentId: argument.id,
          })
          .then(
            () => { },
            (error) => {
              var response = error.response;

              alert(Object.values(response.data.message[0])[0]);

              if (response.status === 401) {
                this.refreshAuthToken(null, true);
              }
            },
          );
      }
    },
    onLikeComment(type, comment) {
      if (!this.globals.userInfo) {
        this.initLogin();
        this.globals.pendingAction =
          type === "like" ? "likeComment" : "dislikeComment";
        this.globals.pendingActionData = comment;
      } else {
        if (type === "like") {
          comment.isLiked = !comment.isLiked;

          if (comment.isLiked) {
            comment.likesCount = comment.likesCount + 1;
          } else {
            comment.likesCount = comment.likesCount - 1;
          }

          if (comment.isDisliked) {
            comment.isDisliked = false;
            comment.dislikesCount = comment.dislikesCount - 1;
          }

          this.fireEvent({
            debateId: this.debate.id,
            userId: this.globals.userKey,
            fingerprintId: this.globals.deviceId,
            eventType: "like_comment",
          });
        } else {
          comment.isDisliked = !comment.isDisliked;

          if (comment.isDisliked) {
            comment.dislikesCount = comment.dislikesCount + 1;
          } else {
            comment.dislikesCount = comment.dislikesCount - 1;
          }

          if (comment.isLiked) {
            comment.isLiked = false;
            comment.likesCount = comment.likesCount - 1;
          }
        }

        axios
          .post("/comment/like", {
            type: type,
            debateId: this.debate.id,
            commentId: comment.id,
          })
          .then(
            () => { },
            (error) => {
              const response = error.response;

              alert(Object.values(response.data.message[0])[0]);

              if (response.status === 401) {
                this.refreshAuthToken(null, true);
              }
            },
          );
      }
    },
    fireEvent(payload) {
      if (window.sidedSessionData && window.sidedSessionData.embedDomainPageId !== undefined) {
        payload.eventSourceId = window.sidedSessionData.embedDomainPageId;
      }

      if (this.debate.clientId) {
        payload.clientId = this.debate.clientId;
      }

      // add embed placement id
      if (window.sidedSessionData && window.sidedSessionData.embedDomainPageId !== undefined) {
        payload.embedDomainPageId = window.sidedSessionData.embedDomainPageId;
      }

      //embedDomainId 

      if (window.sidedSessionData && window.sidedSessionData.embedDomainId !== undefined) {
        payload.embedDomainId = window.sidedSessionData.embedDomainId;
      }



      axios.post("/embed/registerDebateEvent", payload);
    },
    fireEventGA(event, payload = {}) {
      if (window.gtag && this.debateClient && this.debateClient.gaTracking) {
        window.gtag("event", event, payload);
      }
    },
    dispatchEvent() {
      const self = this;

      setTimeout(function () {
        window.dispatchEvent(
          new CustomEvent("sided:init", {
            detail: {
              element: self.$refs.debateHolder
                ? self.$refs.debateHolder.parentElement
                : null,
              pollID: self.debate.id,
              placementID: self.embedPlacementId,
            },
          }),
        );
      }, 500);
    },
    refreshAuthToken(callback = null, enableFallback = false) {
      axios
        .post(
          "/user/refreshToken",
          {},
          {
            headers: { "x-refresh-token": this.globals.refreshToken },
          },
        )
        .then((response) => {
          var token = response.data.token;
          var refreshToken = response.data.refreshToken;

          this.globals.accessToken = token;
          this.globals.refreshToken = refreshToken;
          this.setCookie(this.globals.accessTokenCookieName, token);
          this.setCookie(this.globals.refreshTokenCookieName, refreshToken);

          if (callback) {
            callback();
          }
        })
        .catch(() => {
          if (enableFallback) {
            this.onLogOut();
            this.showProfile = false;
            this.globals.state = "login";
          }
        });
    },
    onBackFromFeed() {
      if (this.feedDebate) {
        this.feedDebate = null;
      } else {
        this.setSidePanelTab("standard");
      }

      setTimeout(() => window.OBR.extern.researchWidget(), 1000);
    },
    setSidePanelTab(newState) {
      this.sidePanelTab = newState;
      this.closeProfile();
    },
    openProfile(user = null, allowOpen = false) {
      if (!this.isPoll || allowOpen) {
        this.showProfile = true;
        this.profileUser = user;
        this.refreshAuthToken();
        this.sidePanelVisible = true;

        if (user) {
          this.loadProfile(user.id);
        }
      }
    },
    loadProfile(id) {
      axios
        .get(`/user/${id}`)
        .then(({ data }) => (this.profileUser = data.data));
    },
    closeProfile() {
      this.showProfile = false;
      this.profileUser = null;
    },
    setFeedDebate(debate) {
      this.feedDebate = debate;
      this.feedDebateArguments = [];

      axios
        .get(`/argument/getSingleFeedList?debateId=${debate.id}`)
        .then((response) => {
          this.feedDebateArguments = response.data.data.map(
            (argument) => new Argument(argument),
          );
        });
    },
    showContentOptions(type, item) {
      this.profileState =
        (this.sidePanelVisible ? "side" : "main") + "/content-options";
      this.sidePanelVisible = true;
      this.openProfile();
      this.contentOptionsType = type;
      this.contentOptionsItem = item;
    },
    closeContentOptions(sidePanelVisible = false) {
      this.sidePanelVisible = sidePanelVisible;
      this.closeProfile();
      this.profileState = "";
      this.resetContentOptions();
    },
    resetContentOptions() {
      this.contentOptionsType = "";
      this.contentOptionsItem = null;
    },
    initSso() {
      this.setData("sided_sso_redirect_to", window.location.href);
      this.setData(
        "sidedEmbedPayload",
        JSON.stringify({
          sidePanelVisible: this.sidePanelVisible,
        }),
      );

      if (localStorage.getItem("pfd_auth_token")) {
        window.sidedSso();
      } else {
        window.location.href = "/login?sso=sided";
      }
    },
    initLogin() {
      if (window.location.host.indexOf("sicscore.com") !== -1) {
        this.initSso();
      } else {
        this.globals.state = "login";
      }
    },
    initSignup() {
      if (window.location.host.indexOf("sicscore.com") !== -1) {
        this.initSso();
      } else {
        this.globals.state = "signup";
      }
    },
    closeEmailModal() {
      if (this.debateHistory.length === 1) {
        if (this.debateNextList.length > 0) {
          this.loadNextItem(this.debateNextList[0], () => {
            this.showNextDebate();
          });
        }
      } else {
        const currentDebateIndex = this.debateNextList.indexOf(this.debate.id);
        const nextDebateId = this.debateNextList[currentDebateIndex + 1] || -1;
        const debateData = this.debateHistory.find(
          ({ id }) => id === nextDebateId,
        );

        if (debateData) {
          this.initDebate(debateData);
        } else if (nextDebateId !== -1) {
          this.loadNextItem(nextDebateId, () => {
            this.showNextDebate();
          });
        }
      }
    },
    refreshDebateHistory() {
      this.debateHistory.forEach(({ id }) => {
        const { deviceId, userKey } = this.globals;
        axios
          .get(`/debate/${id}?deviceId=${deviceId}&uniqueUserId=${userKey}${this.sequenceId ? "&sequenceId=" + this.sequenceId : ""}`)
          .then(({ data }) => {
            const index = this.debateHistory.findIndex(
              (debate) => debate.id === data.data.id,
            );
            this.debateHistory[index] = new Debate(data.data);
          });
      });
    },
  },
};
</script>
